// @flow
'use strict';

import * as React from 'react';

import type { IIcms20 } from '../../../types_imposto';

import ColumnDetalhes from '../../../../../common/detalhes_documento/column_detalhes';
import RowDetalhes from '../../../../../common/detalhes_documento/row_detalhes';

type Icms20Props = {
  icms : IIcms20,
};

export default function Icms20({ icms } : Icms20Props) {
  return (
      <>
        <h4>ICMS - 20 = Tributado com redução da BC</h4>
        <RowDetalhes data={ icms } className="no-margin-bottom">
          <ColumnDetalhes field="cst" width="50%">Classificação Tributária do Serviço</ColumnDetalhes>
          <ColumnDetalhes field="percReducaoBc" type="percentual" width="50%">Percentual de Redução de Base de Cálculo</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ icms } className="no-margin-bottom">
          <ColumnDetalhes field="valorBc" type="moeda" width="50%">Valor da Base de Cálculo do ICMS</ColumnDetalhes>
          <ColumnDetalhes field="aliquota" type="percentual" width="50%">Alíquota do ICMS</ColumnDetalhes>
        </RowDetalhes>
        <RowDetalhes data={ icms }>
          <ColumnDetalhes field="valor" type="moeda">Valor do ICMS</ColumnDetalhes>
        </RowDetalhes>
      </>
  );
}
